import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Chip, Tab, Tabs } from '@mui/material';

const EditShowModal = ({ open, handleClose, showDetails, handleSave }) => {
    const [updatedDetails, setUpdatedDetails] = useState(showDetails);
    const [selectedTab, setSelectedTab] = useState(0);
    const [newTag, setNewTag] = useState('');
    const [showOverlay, setShowOverlay] = React.useState(false);
    const [isAutoGeneratePopupOpen, setAutoGeneratePopupOpen] = useState(false);
    const [selectedThumbnail, setSelectedThumbnail] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value
        }));
    };

    const handleThumbnailSelection = () => {
        if (selectedThumbnail) {
          console.log('Selected Thumbnail:', selectedThumbnail);
          // You can perform other actions like saving the selected thumbnail to a backend or state
          setUpdatedDetails((prevDetails) => ({
            ...prevDetails,
            Thumbnail: selectedThumbnail.ThumbnailURL, // Update the Thumbnail with base64 string
            uploadType: "s3Key",
            ThumbnailBucket: selectedThumbnail.ThumbnailBucket,
            ThumbnailKey: selectedThumbnail.ThumbnailKey
        }));
        }
        setAutoGeneratePopupOpen(false)
      };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleNewTagChange = (e) => {
        setNewTag(e.target.value); // Update the newTag state as user types
    };

    const handleAddTag = (e) => {
        if (e.key === 'Enter' && newTag.trim()) {
            // Add the tag to the list if it's not empty
            setUpdatedDetails((prevDetails) => ({
                ...prevDetails,
                Tags: [...prevDetails.Tags, newTag.trim()],
            }));
            setNewTag(''); // Reset the newTag input field
        }
    };

    const handleDeleteTag = (tagToDelete) => {
        setUpdatedDetails((prevDetails) => ({
            ...prevDetails,
            Tags: prevDetails.Tags.filter((tag) => tag !== tagToDelete),
        }));
    };

    const handleSubmit = () => {
        handleSave(updatedDetails); // Pass updated details to the parent component
        handleClose(); // Close the modal
    };

    useEffect(() => {
        if (open) {
            setUpdatedDetails(showDetails);
        }
    }, [open, showDetails]);

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result;
                setUpdatedDetails((prevDetails) => ({
                    ...prevDetails,
                    Thumbnail: base64Image, // Update the Thumbnail with base64 string
                    uploadType: "base64"
                }));
            };
            reader.readAsDataURL(file); // Read the file as a base64 string
        }
    };
    const handleAutoGenerateThumbnail = () => {
        console.log('Thumbnail auto-generated');
        setAutoGeneratePopupOpen(true); // Open the popup when the button is clicked
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth
            sx={{
                '& .MuiPaper-root': {
                    backgroundColor: '#19193e', // Set the background color
                    color: 'white' // Adjust text color for contrast
                }
            }}>
            <DialogTitle>Edit Show Details</DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {/* Left side: Thumbnail and Show Name / Tags */}
                    <div style={{
                        width: '30%', marginRight: '20px', borderRight: '1px solid white',
                        paddingRight: '2%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'
                    }}>
                        {/* Thumbnail */}
                        <div
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: '30vh',
                                marginBottom: '10px',
                                borderRadius: '8px',
                                overflow: 'hidden', // Ensures overlay stays within the div
                            }}
                            onMouseEnter={() => setShowOverlay(true)} // Show overlay on hover
                            onMouseLeave={() => setShowOverlay(false)} // Hide overlay when not hovered
                        >
                            {updatedDetails?.Thumbnail ? (
                                <img
                                    src={updatedDetails.Thumbnail}
                                    alt="Show Thumbnail"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                    }}
                                />
                            ) : (
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: '#d3d3d3',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: '#555',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                    }}
                                >
                                    Thumbnail not available
                                </div>
                            )}
                            <input
                                id="thumbnail-upload"
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }} // Hide the file input
                                onChange={handleThumbnailChange} // Handle file change
                            />
                            {/* Overlay and buttons */}
                            {showOverlay && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: '8px',
                                        color: '#fff',
                                    }}
                                >
                                    <button
                                        style={{
                                            padding: '10px 20px',
                                            margin: '10px',
                                            // backgroundColor: '#007bff',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                        }}
                                        className="join-btn"
                                        onClick={() => document.getElementById('thumbnail-upload').click()}
                                    >
                                        File Upload
                                    </button>
                                    <button
                                        style={{
                                            padding: '10px 20px',
                                            margin: '10px',
                                            // backgroundColor: '#007bff',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                        }}
                                        className="join-btn"
                                        onClick={handleAutoGenerateThumbnail}
                                    >
                                        Auto Generate
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Show Name and Tags */}
                        <TextField
                            fullWidth
                            label="Show Name"
                            name="ShowName"
                            value={updatedDetails?.ShowName || ''}
                            onChange={handleChange}
                            margin="normal"
                            variant="filled"
                            sx={{
                                background: '#2d2d4d'
                            }}
                        />
                        <TextField
                            fullWidth
                            label="Tags"
                            value={newTag}
                            onChange={handleNewTagChange}
                            onKeyPress={handleAddTag} // Listen for Enter key
                            margin="normal"
                            variant="filled"
                            sx={{
                                background: '#2d2d4d'
                            }}
                        />

                        <div style={{ marginTop: '10px' }}>
                            {updatedDetails?.Tags?.map((tag, index) => (
                                <Chip
                                    key={index}
                                    label={tag}
                                    onDelete={() => handleDeleteTag(tag)} // Deleting a tag
                                    style={{ margin: '5px' }}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Right side: Tabs */}
                    <div style={{ flexGrow: 1 }}>
                        <Tabs value={selectedTab} onChange={handleTabChange} aria-label="edit show details tabs" indicatorColor="primary" textColor="primary" centered>
                            <Tab label="Summary" sx={{ textTransform: 'none' }} />
                            <Tab label="Transcript" sx={{ textTransform: 'none' }} />
                            <Tab label="Agenda" sx={{ textTransform: 'none' }} />
                            <Tab label="Guest Details" sx={{ textTransform: 'none' }} />
                        </Tabs>

                        <div style={{ paddingTop: '20px' }}>
                            {/* Tab Content */}
                            {selectedTab === 0 && (
                                <TextField
                                    fullWidth
                                    label="Summary"
                                    name="summary"
                                    value={updatedDetails?.summary || ''}
                                    onChange={handleChange}
                                    margin="normal"
                                    multiline
                                    rows={15}
                                    variant="filled"
                                    sx={{
                                        background: '#2d2d4d'
                                    }}
                                />
                            )}
                            {selectedTab === 1 && (
                                <TextField
                                    fullWidth
                                    label="Transcript"
                                    name="Transcript"
                                    value={updatedDetails?.Transcript || ''}
                                    onChange={handleChange}
                                    margin="normal"
                                    multiline
                                    rows={15}
                                    variant="filled"
                                    sx={{
                                        background: '#2d2d4d'
                                    }}
                                />
                            )}
                            {selectedTab === 2 && (
                                <TextField
                                    fullWidth
                                    label="Agenda"
                                    name="Agenda"
                                    value={updatedDetails?.Agenda || ''}
                                    onChange={handleChange}
                                    margin="normal"
                                    multiline
                                    rows={15}
                                    variant="filled"
                                    sx={{
                                        background: '#2d2d4d'
                                    }}
                                />
                            )}
                            {selectedTab === 3 && (
                                <TextField
                                    fullWidth
                                    label="Guest Details"
                                    name="GuestInfo"
                                    value={updatedDetails?.GuestInfo || ''}
                                    onChange={handleChange}
                                    margin="normal"
                                    multiline
                                    rows={15}
                                    variant="filled"
                                    sx={{
                                        background: '#2d2d4d'
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} className="cancel-btn">
                    <span className='text-trans-none'>
                        Cancel
                    </span>
                </Button>
                <Button onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    className="join-btn"
                    >
                    <span className='text-trans-none'>
                        Save
                    </span>
                </Button>
            </DialogActions>
            <Dialog
                open={isAutoGeneratePopupOpen}
                onClose={() => setAutoGeneratePopupOpen(false)}
                sx={{
                    '& .MuiPaper-root': {
                        backgroundColor: '#19193e', // Set the background color
                        color: 'white', // Adjust text color for contrast
                        width: (updatedDetails?.thumbnailImages && updatedDetails.thumbnailImages.length > 0) ? '100%' : 'auto',
                    },
                }}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Auto-generated Thumbnails</DialogTitle>
                <DialogContent>
                    {!updatedDetails?.thumbnailImages || updatedDetails.thumbnailImages.length === 0 ? (
                        <div>
                            <p>It looks like there is no thumbnail for this show. Feel free to upload one if you'd like!</p>
                        </div>
                    ) : (
                        <div className="col-12 mt-3 mb-3">
                        {updatedDetails?.thumbnailImages.length > 0 ? (
                            <div className="row">
                                {updatedDetails?.thumbnailImages.map((video, index) => (
                                    <div
                                        className="col-lg-4 col-md-4 col-sm-12 mb-3"
                                        key={index}
                                        onClick={() => setSelectedThumbnail(video)} // Set selected thumbnail
                                        style={{
                                            cursor: 'pointer',
                                            border: selectedThumbnail?.ThumbnailURL === video.ThumbnailURL ? '3px solid #4caf50' : 'none', // Highlight selection
                                        }}
                                    >
                                        <img
                                            src={video.ThumbnailURL}
                                            alt="Thumbnail"
                                            style={{ width: '100%', height: '150px', objectFit: 'contain' }}
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                                <div>
                                    <p>It looks like there is no thumbnail for this show. Feel free to upload one if you'd like!</p>
                                </div>
                            )}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAutoGeneratePopupOpen(false)} color="primary">
                        Close
                    </Button>
                    {selectedThumbnail && (
                        <Button onClick={handleThumbnailSelection} color="primary">
                            Confirm Selection
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </Dialog>
    );
};

export default EditShowModal;
